import { useInfiniteQuery, useQuery } from 'react-query'
import { getTransactions } from 'services/transactions'

export default function useGetTransactions() {
    const { data, isLoading, fetchNextPage } = useInfiniteQuery(
        ['money-pools-detail-users-in-funds'],
        ({ pageParam = 1, queryKey }) => getTransactions(pageParam),
        {
            getNextPageParam: (lastPage, allPages) => {
                const lastRecord = allPages[allPages.length - 1]?.next || ''
                return lastRecord
                    ? new URL(lastRecord).searchParams.get('cursor')
                    : undefined
            },
        }
    )
    return { data, isLoading, fetchNextPage }
}
